import { saveVariantFilterGridState as saveVariantFilterGridStateDiagram  } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    columnState: [];
};

export const saveVariantFilterGridState = ({
    columnState,
}: Props) => {
    saveVariantFilterGridStateDiagram(columnState);
};
